import { useAuthContext } from './agencyAuthHook'
import { getAllConfigurations } from '../redux/reducers/configSlice'
import { useDispatch } from 'react-redux';

export default function ConfigurationsHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getConfigurations=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/configurations/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllConfigurations(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getConfigurations}
}
